import styled from 'styled-components';

export const ProductFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  padding: 18px 0;

  div:nth-child(1) {
    margin-bottom: 30px;
  }
`;
